module.exports = __webpack_public_path__ + "static/grafika3-ee681c82a51203101b29ff8f576b53a1.png";